export default "__VITE_ASSET__BSx$$wt9__"